<template>
    <div class="page5">
        <div class="idenP-privilege">
            <div class="title">
                <div class="priv-title">身份特权</div>
                <div class="priv-desc">彰显尊贵身份，随时随地与众不同</div>
            </div>
            <div class="job-comment">
                <div class="job-swiper-pagination">
                    <div class="jobPrivi-icon">
                        <ul>
                            <li class="icon-page hover-class" v-for="(item, index) in commentData" @mouseenter="enter(index)" @mouseleave="leave()" @click="show(item.clickShow, item.actionType)">
                                <div class="icon-radius">
                                    <div class="icon-box" :class="{'active': index === currentIndex}">
                                        <div class="icon" :style="{backgroundImage: 'url('+ item.iconUrl +')', backgroundSize: 'contain'}"></div>
                                    </div>
                                </div>
                                <p class="detail-text">查看详情</p>
                                <div class="icon-title">{{ item.privTitle }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="comment-display">
                    <!-- 每次页面显示三个，所以让当前的、前一个和后一个显示    再分别给每个添加类，显示在不同的位置 -->
                    <div v-for="(item, index) in commentData" v-if="index === currentIndex " class="comment-box" :class="{'dialog-box-active': index === currentIndex, [item.itemClass]: index === currentIndex}" :key="index">
                        <div class="comment" v-show="index === currentIndex || index === prevIndex || index === nextIndex">
                            <div class="arrow">
                                <div class="hidden-line"></div>
                            </div>
                            <div class="dialog-box">
                                <p class="comment-text">
                                    <span class="mark-max"> “</span>
                                    <span class="text" v-html="item.comments[randomIndex].commentText">
                                    </span>
                                </p>
                                <div class="priv-result">
                                    {{ item.comments[randomIndex].privResult }}<span class="result">{{ item.comments[randomIndex].result }}</span>
                                </div>
                                <p class="comment-from">{{ item.comments[randomIndex].commentFrom }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-bg"></div>
                </div>
            </div>
            <div class="btn-buyvip">
                <p class="btn-text" @click="buyVipDialog('pc-cvip-huiyuantequan-zhangxianzunguishenfeb')">立即开启与众不同</p>
            </div>

        </div>
    </div>
</template>

<script>
    /**
     * 身份特权
     */
    import { commentData } from '@/data/data.js';
    import { getResumeHighlight } from '../../../../api/index.js';
    import { mapGetters, mapActions } from 'vuex';
    export default {
        name: 'idenPrivilege',
        props: ['cvipstate'],
        data(){
            return {
                currentIndex: 0, //当前的 index
                prevIndex: 0,    //前一张 index
                nextIndex: 0,    //后一张 index
                randomIndex: 0,  //从评论数组里随机获取数据
                commentData: commentData.idenPrivData,     //评论内容数据
                idenPTimer: null  //轮播定时器
            }
        },
        mounted() {
            this.autoplay();
        },
        methods: {
            autoplay(){
                this.play();
                this.idenPTimer = setInterval(this.play, 5000);
            },
            //返回0到3的随机数
            randomNum() {
                return Math.floor(Math.random() * 3);
            },
            play(){
                //生成随机数
                this.randomIndex = this.randomNum();
                this.currentIndex ++;
                //取轮播到当前的上一张和下一张
                this.prevIndex = this.currentIndex === 0 ? 5 : this.currentIndex - 1;
                this.nextIndex = this.currentIndex === 2 ? 0 : this.currentIndex + 1;
                // 到最后一张时候下一张到第一张
                if( this.currentIndex === this.commentData.length) {
                    this.currentIndex = 0;
                    this.nextIndex = this.currentIndex + 1;
                }
            },
            //鼠标移入
            enter(index) {
                this.currentIndex = index-1;
                this.play();
                clearInterval(this.idenPTimer);
            },
            //鼠标离开
            leave(index) {
                this.idenPTimer = setInterval(this.play, 5000);
            },
            //显示特权
            show(type, actionType) {
                window.clickLog && window.clickLog(`from=${actionType}-new`);
                this.$emit('showPrivilDialog', type, actionType);
            },
            //购买弹窗
            buyVipDialog(actionType) {
                this.$emit('buyDialog');
                window.clickLog && window.clickLog(`from=${actionType}-new`);
            }
        },
        computed: {
            ...mapGetters({
                cvipMes: 'cvipMes',
                rightUsed: 'rightUsed', //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
                resumeListNum: 'resumeListNum',
                getinsurance: ''
            }),
            vipState(){ //会员状态   新版会员 || 老版会员
                return this.$store.getters.getinsurance.code
            },
            insuranceState(){
                return this.$store.getters.getAccidentInsuranceState.code 
            }
        }
    }
</script>

<style lang="scss" scope>
    .page5{
        height: 100%;
        width: 100%;
        position: relative;
        background: url(../../../../assets/imgs/bg-page3.png) no-repeat center;
        background-size: 100% 100%;
    }
    .idenP-privilege{
        width: 1190px;
        height: 750px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        .title{
            padding-top: 75px;
            margin-bottom: 70px;
            .priv-title{
                font-size: 44px;
                color: #FFFFFF;
                letter-spacing: 0;
                text-align: center;
            }
            .priv-desc{
                opacity: 0.5;
                font-size: 20px;
                color: #FFFFFF;
                letter-spacing: 0;
                text-align: center;
                line-height: 40px;
            }
        }
        .job-comment{
            height: 420px;
            width: 100%;
            .comment-display{
                height: 260px;
                width: 1100px;
                overflow: hidden;
                margin: 0 auto;
                padding-top: 60px;
                position: relative;

                .dialog-box-active{
                    position: absolute;
                    opacity: 1;
                    z-index: 5;
                }
                .dialog-box-prev{
                    top: 100px;
                    left: 50px;
                    opacity: .1;
                    position: absolute;
                }
                .dialog-box-next{
                    top: 130px;
                    right: 0;
                    opacity: .1;
                    position: absolute;
                }
                .fade-enter-active, .fade-leave-active {
                    transition: opacity .5s;
                    -moz-transition: all .5s;
                    -webkit-transition: all .5s;
                    -o-transition: all .5s;
                }
                .fade-enter, .fade-leave-to {
                    opacity: 0;
                }
                .comment-box {
                    &.dialog-box-active{
                        width: 100%;
                        position: absolute;
                        opacity: 1;
                        z-index: 5;
                        left: 20px;
                        .comment{
                            width: 699px;
                            margin-left: 120px;
                            .dialog-box{
                                width: 699px;
                            }
                        }
                    }
                    &.dialog-box-prev{
                        width: 699px;
                        top: 100px;
                        left: 50px;
                        opacity: .05;
                        position: absolute;
                    }
                    &.dialog-box-next{
                        width: 699px;
                        top: 130px;
                        left: 180px;
                        opacity: .05;
                        position: absolute;
                    }
                    //给每个评论定位
                    &.item-zgbs{
                        .arrow{
                            // left: 255px;
                            left: 326px;
                        }
                    }
                    &.item-grrz{
                        .arrow{
                            left: 395px;
                        }
                    }
                    &.item-hjld{
                        .arrow{
                            // left: 535px;
                            left: 468px;
                        }
                    }
                }
                .comment{
                    height: 176px;
                    width: 701px;
                    position: relative;
                    .arrow{
                        width: 26px;
                        height: 16px;
                        background: url(../../../../assets/imgs/dialog-arrow.png) no-repeat center;
                        background-size: 100% 100%;
                        position: absolute;
                        top: -15px;
                        left: 30px;
                        .hidden-line{
                            width: 24px;
                            height: 1px;
                            background: #262216;
                            position: absolute;
                            left: 1px;
                            bottom: 0px;
                        }
                    }
                    .dialog-box{
                        height: 156px;
                        width: 660px;
                        padding: 0 20px;
                        border-radius: 5px;
                        margin-top: 20px;
                        border: 1px solid #E9CD9B;
                        background: rgba(38,34,31,0.70);
                        .comment-text{
                            padding-top: 37px;
                            font-size: 16px;
                            color: #E6CA99;
                            letter-spacing: 0;
                            line-height: 26px;
                            .text{
                                display: inline-block;
                                width: 91%;
                                margin-left: 15px;
                            }
                            .mark-max{
                                font-size: 60px;
                                color: #E6CA99;
                                letter-spacing: 0;
                                display: inline-block;
                                font-family: Arial;
                            }
                            .mark-light{
                                font-size: 16px;
                                color: #fff;
                                letter-spacing: 0;
                                line-height: 26px;
                            }
                        }
                        .priv-result{
                            font-size: 16px;
                            color: #FFFFFF;
                            letter-spacing: 0;
                            line-height: 26px;
                            padding: 14px 0 0 40px;
                            .result{
                                font-size: 22px;
                                color: #fff;
                                letter-spacing: 0;
                                line-height: 26px;
                                display: inline-block;
                                vertical-align: middle;
                                margin-top: -2px;
                            }
                        }
                        .comment-from{
                            display: inline-block;
                            font-size: 14px;
                            color: #E6CA99;
                            letter-spacing: 0;
                            line-height: 26px;
                            opacity: 0.5;
                            position: absolute;
                            right: 10px;
                            bottom: 30px;
                        }
                    }
                    
                }
                .dialog-bg{
                    height: 202px;
                    width: 1100px;
                    background: url(../../../../assets/imgs/dialog-demo-bg.png) no-repeat center;
                    margin-top: 40px;
                }
            }
            //分页器
            .jobPrivi-icon{
                width: auto;
                height: 68px;
                margin: 0 auto;
                position: relative;
                text-align: center;
                .icon-page{
                    height: 68px;
                    width: 68px;
                    position: relative;
                    margin-right: 72px;
                    display: inline-block;
                    cursor: pointer;
                    .icon-box{
                        height: 100%;
                        width: 100%;
                        border-radius: 50%;
                        background: url(../../../../assets/imgs/icon-bg.png) no-repeat center;
                        position: absolute;
                        transition: all .5s;
                        -moz-transition: all .5s;
                        -webkit-transition: all .5s;
                        -o-transition: all .5s;
                    }
                    .active{
                        background: url(../../../../assets/imgs/icon-chosed.png) no-repeat center;
                        background-size: 100% 100%;
                        .icon{
                            opacity: 1;
                        }
                    }
                    .icon{
                        opacity: .5;
                        height: 53px;
                        width: 53px;
                        margin: 0 auto;
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 7px;
                        border-radius: 50%;
                        background: url(../../../../assets/imgs/icon-jlzd.png) no-repeat center;
                        background-size: 100% 100%;
                    }
                    .detail-text{
                        width: 32px;
                        margin: 0 auto;
                        vertical-align: middle;
                        font-size: 14px;
                        color: #333333;
                        line-height: 17px;
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        top: 18px;
                        opacity: 0;
                        transition: all .5s;
                        -moz-transition: all .5s;
                        -webkit-transition: all .5s;
                        -o-transition: all .5s;
                    }
                    .icon-title{
                        position: absolute;
                        bottom: -28px;
                        width: 100%;
                        text-align: center;
                        opacity: 0.3;
                        font-size: 15px;
                        color: #FFFFFF;
                        letter-spacing: 0;
                        transition: all .5s;
                        -moz-transition: all .5s;
                        -webkit-transition: all .5s;
                        -o-transition: all .5s;
                    }

                    &:hover {
                        .icon{
                            display: none;
                        }
                        .icon-radius{
                            width: 68px;
                            height: 68px;
                            position: absolute;
                            left: 0;
                            top: 0;
                            border-radius: 50%;
                            overflow: hidden;
                        }
                        .icon-box{
                            opacity: 1;
                            filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#E2C590",endColorStr="#CCA768",gradientType="0");
                            background-image: linear-gradient(-212deg, #E2C590 0%, #CCA768 100%);
                            border-radius: 50% ;
                            transform: rotateY(180deg);
                        }
                        .detail-text{
                            opacity: 1;
                        }
                        .icon-title {
                            opacity: 0.7;
                            font-size: 15px;
                            color: #FFFFFF;
                            letter-spacing: 0;
                        }
                    }
                }
                .icon-page:last-child{
                    margin-right: 0;
                }
            }
        }
        .btn-buyvip{
            width: 428px;
            height: 95px;
            margin: -20px auto;
            background: url(../../../../assets/imgs/buybtn.png) no-repeat center;
            background-size: 100% 100%;
            cursor: pointer;
            &:hover {
                background: url(../../../../assets/imgs/buybtn-hover.png) no-repeat center;
                background-size: 100% 100%;
            }
            .btn-text{
                height: 50px;
                line-height: 50px;
                padding-top: 14px;
                font-weight: bold;
                font-size: 16px;
                color: #403C36;
                letter-spacing: 0;
                text-align: center;
                text-shadow: 0 1px 0 rgba(255,255,255,0.22);
            }
        }

    }
</style>



// WEBPACK FOOTER //
// IdenPrivilege.vue?38a336bd